import { useT } from "@/i18n";
import { SparkMascot } from "@/components/Mascots";
import { GAME_TEXT } from "@/components/games/content";
import BlockBuilder from "@/components/games/BlockBuilder";
import StarCatcher from "@/components/games/StarCatcher";
import RaceGame from "@/components/games/RaceGame";
import LegoBuilder from "@/components/games/LegoBuilder";
import ScratchRecipe from "@/components/games/ScratchRecipe";
import GameTools from "@/components/games/GameTools";

export default function GamesWorkshop() {
  const { lang } = useT();
  const tx = GAME_TEXT[lang];
  return (
    <section className="learn-bg rounded-[2rem] border-4 border-white shadow-xl p-5 sm:p-8 mt-8 space-y-12" data-testid="games-workshop">
      <div>
        <div className="flex items-center gap-4">
          <SparkMascot className="w-20 sm:w-28 shrink-0" />
          <h2 className="font-fredoka text-2xl sm:text-4xl font-bold bubble-text text-white">{tx.title}</h2>
        </div>
        <p className="mt-4 bg-white/90 rounded-3xl px-5 py-3 font-bold text-blue-900 shadow-md">{tx.intro}</p>
      </div>
      <BlockBuilder />
      <StarCatcher />
      <RaceGame />
      <LegoBuilder />
      <ScratchRecipe />
      <GameTools />
    </section>
  );
}
